import React from 'react';
import { FieldAttributes } from 'formik';

import { Situacao, Situacoes } from 'model/solicitacao/Situacao';

import Lozenge from '@atlaskit/lozenge';


export interface SituacaoTagProps extends FieldAttributes<any> {
    situacao?: Situacao
}

const appearances = {
  [Situacoes.EM_ABERTO.id]: 'new',
  [Situacoes.EM_ANDAMENTO.id]: 'inprogress',
  [Situacoes.AGUARDANDO_PARECER_SOLICITANTE.id]: 'moved',
  [Situacoes.CONCLUIDO.id]: 'success',
  [Situacoes.FECHADO.id]: 'success',
  [Situacoes.CANCELADO.id]: 'default'
}

export const SituacaoTag: React.FunctionComponent<SituacaoTagProps> = ({situacao, className}) => {
  const appearance = situacao ? appearances[situacao.id] : 'default'
  const descricao = situacao ? situacao.nome : 'CARREGANDO SITUAÇÃO'

  return <span className={className}><Lozenge appearance={appearance as any}>{descricao}</Lozenge></span>
}
